import { Injectable } from '@angular/core';
import { CacheService } from '../../../../../../projects/common/src/app/services/cache.service';
import { StatusService } from '../../../core/services/parameter/status/status.service';
import { Logger } from '../../../../../../projects/common/src/app/classes/logger';

@Injectable({
  providedIn: 'root',
})
export class ZoneHandlerService extends Logger {
  constructor(private cacheService: CacheService, private statusService: StatusService) {
    super();
  }

  /**
   * Function to verify and assign selected zone
   *
   * @param url url path to evaluate navigation
   */
  public async verifySelectedZone(url: string): Promise<void> {
    const lastParameter = parseFloat(url.split('/').pop());
    if (url !== '/app' && url.indexOf('dsh') !== -1) {
      if (!isNaN(lastParameter)) {
        const availableZones = this.cacheService.session('availableZones');
        if (!availableZones) {
          await this.getAvailableZonesAndSaveSelected(lastParameter);
        } else {
          const selectedZoneData = availableZones.find((zone) => zone.zoneId === lastParameter);
          this.checkSelectedZone(selectedZoneData, lastParameter);
        }
      } else {
        this.cacheService.saveSession('selectedZone', { zoneId: '-1', zoneName: '' });
      }
    }
  }

  /**
   * Function to get available zones and save selected zone
   *
   * @param zoneId to save selected zone
   */
  private async getAvailableZonesAndSaveSelected(zoneId: number): Promise<any> {
    const zoneList = await this.statusService.getParkZone().toPromise();
    const selectedZoneData = zoneList.data.find((zone) => zone.zoneId === zoneId);
    this.cacheService.saveSession('availableZones', zoneList.data);
    this.checkSelectedZone(selectedZoneData, zoneId);
  }

  /**
   * Function to check if selected zone exists
   *
   * @param selectedZoneData to save on sessionStorage
   * @param zoneId to save selected zone
   */
  private checkSelectedZone(selectedZoneData: any, zoneId: number): void {
    if (selectedZoneData) {
      this.cacheService.saveSession('selectedZone', { zoneId, zoneName: selectedZoneData.name });
    } else {
      this.error('No se encontraron zonas para el tipo de zona configurado en environment.clientZoneType');
    }
  }
}
